export default {
  setUser: (state, user) => {
    state.user = {...state.user, ...user}
  },
  unsetUser: state => {
    state.user = { email: null, metadata: null };
  },
  setSelectedAgs: (state, payload) => {
    if (payload.selectedAgsId) {
      state.selectedAgs = payload.agsList.find(
        ags => ags.agsId == payload.selectedAgsId
      );
    } else {
      state.selectedAgs = null;
    }
  },
  setSelectedUpdate: (state, payload) => {
    var updateList = payload.updateList ? payload.updateList : state.updates;
    if (payload.selectedUpdateId) {
      state.selectedUpdate = updateList.find(
        update => update.updateId == payload.selectedUpdateId
      );
    } else {
      state.selectedUpdate = null;
    }
  },
  setSelectedYearIndex: (state, i) => {
    state.selectedYearIndex = i;
  },
  setUpdates: (state, updates) => {
    state.updates = updates;
  },
  addUpdate: (state, update) => {
    state.updates.push(update);
  },
  // override update attributes
  patchUpdate: (state, update) => {
    var updateToPatch = state.updates.find(u => u.updateId == update.updateId);
    Object.assign(updateToPatch, update);
  },
  setAgs: (state, ags) => {
    state.ags = ags;
  },
  setPointLayerTypes: (state, pointLayerTypes) => {
    state.pointLayerTypes = pointLayerTypes;
  },
  setTileLayerTypes: (state, tileLayerTypes) => {
    state.tileLayerTypes = tileLayerTypes;
  },
  setHeatMapLayerTypes: (state, heatMapLayerTypes) => {
    state.heatMapLayerTypes = heatMapLayerTypes;
  },
  setGeoInputTypes: (state, geoInputTypes) => {
    state.geoInputTypes = geoInputTypes;
  },
  berechnungsparameterAnpassen: () => {},
  nextStep: () => {},
  resetSelectedAgs: () => {},
  resetSelectedUpdate: () => {},
  showSnackbar: (state, { text, type, timeout }) => {
    state.snackbar = { text, type, timeout };
  }
};
